// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Logout Page Container */
.logout-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f3f3f3;
}

/* Logout Card */
.logout-card {
  border-radius: 0;
  border: 1px solid rgba(0, 0, 0, 0.06);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08) !important;
  background-color: #ffffff;
  transition: box-shadow 0.2s ease-in-out;
}

.logout-card:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12) !important;
}

/* Icon Container */
.logout-icon-container {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.logout-icon {
  font-size: 4rem !important;
  width: 4rem !important;
  height: 4rem !important;
  color: #006BF2;
}

/* Animations */
@keyframes scaleIn {
  from {
    opacity: 0;
    transform: scale(0.5);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

/* Responsive Design */
@media (max-width: 576px) {
  .logout-card .card-body {
    padding: 2rem 1.5rem !important;
  }

  .logout-icon {
    font-size: 3rem !important;
    width: 3rem !important;
    height: 3rem !important;
  }

  .login-again-btn {
    padding: 0.625rem 1.5rem !important;
    font-size: 0.9375rem;
  }
}
`, "",{"version":3,"sources":["webpack://./projects/ai_modernization/src/app/logout/logout.component.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,qCAAqC;EACrC,oDAAoD;EACpD,yBAAyB;EACzB,uCAAuC;AACzC;;AAEA;EACE,qDAAqD;AACvD;;AAEA,mBAAmB;AACnB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,sBAAsB;EACtB,uBAAuB;EACvB,cAAc;AAChB;;AAEA,eAAe;AACf;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,+BAA+B;EACjC;;EAEA;IACE,0BAA0B;IAC1B,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,mCAAmC;IACnC,oBAAoB;EACtB;AACF","sourcesContent":["/* Logout Page Container */\n.logout-page {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #f3f3f3;\n}\n\n/* Logout Card */\n.logout-card {\n  border-radius: 0;\n  border: 1px solid rgba(0, 0, 0, 0.06);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08) !important;\n  background-color: #ffffff;\n  transition: box-shadow 0.2s ease-in-out;\n}\n\n.logout-card:hover {\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12) !important;\n}\n\n/* Icon Container */\n.logout-icon-container {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.logout-icon {\n  font-size: 4rem !important;\n  width: 4rem !important;\n  height: 4rem !important;\n  color: #006BF2;\n}\n\n/* Animations */\n@keyframes scaleIn {\n  from {\n    opacity: 0;\n    transform: scale(0.5);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n/* Responsive Design */\n@media (max-width: 576px) {\n  .logout-card .card-body {\n    padding: 2rem 1.5rem !important;\n  }\n\n  .logout-icon {\n    font-size: 3rem !important;\n    width: 3rem !important;\n    height: 3rem !important;\n  }\n\n  .login-again-btn {\n    padding: 0.625rem 1.5rem !important;\n    font-size: 0.9375rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
